<template lang="pug">
v-bottom-sheet(v-if="showDialog" v-model="showDialog" :max-width="600" persistent fluid scrollable content-class="round-2xl")
  v-sheet.pa-4(style="border-radius: 16px 16px 0 0;")
    div.d-flex.align-center
      div(style="width: 28px;")
      v-spacer
      .text-md.font-semibold Share
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close

    div.text-md.font-semibold.neutral700--text.mt-5 Share this stock take sheet:
    v-card.pa-3.mt-4(color="neutral200" flat)
      div.text-md.font-semibold.neutral700--text {{ stocktake.name }}
      div
        div.d-flex.align-center
          v-icon(color="neutral700" size="22") $yzi-users-solid-03
          div.text-sm.neutral700--text.ml-3 {{ stocktake.member.name }}
      div
        div.d-flex.align-center
          v-icon.mb-1(color="neutral700" size="22") $yzi-calendar-solid
          div.text-sm.neutral700--text.font-semibold.ml-3 Start date:
          div.text-sm.neutral700--text.ml-1 {{ stocktake.created | humanizeDate }}
      div
        div.d-flex.align-center
          v-icon.mb-1(color="neutral700" size="22") $yzi-clock-check-solid
          div.text-sm.neutral700--text.font-semibold.ml-3 Time started:
          div.text-sm.neutral700--text.ml-1 {{ stocktake.created | displayTime2 }}

    v-row.mt-3
      v-col
        y-button(label="Done" outlined color="neutral700" size="sm" block @click="closeDialog")
      v-col
        y-button(label="Copy link" prepend-icon="$yzi-copy-03" icon-size="20" size="sm" dark block @click="copyLink")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    stocktake: {
      type: Object,
      default: (() => {})
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {},
  methods: {
    ...mapActions(['showMessage']),
    copyLink () {
      let textToCopy = encodeURI(`https://${process.env.VUE_APP_BASE_DOMAIN}/stocktake/${this.stocktake.id}`)
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          this.showMessage(['success', 'Link copied!'])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        })
    },
    closeDialog () {
      this.showDialog = false
      this.$emit('closed')
    },
  }
}
</script>

<style lang="scss" scoped>
.clipboard-custom {
  font-size: 14px;
  color: white;
  background: var(--v-neutral700);
  padding: 2px 12px;
  border-radius: 6px;
}
</style>